import { z } from 'zod';

/**
 * @description Sport::Session _type properties
 * @see ConstantsService::SPORT_LAP__TYPES
 */

export enum SPORT_LAP_TYPES {
  SPORT_LAP = 'Sport::Lap',
  SPORT_LAP_BIKE = 'Sport::Lap::Bike',
  SPORT_LAP_FITNESS = 'Sport::Lap::Fitness',
  SPORT_LAP_HIKE = 'Sport::Lap::Hike',
  SPORT_LAP_OTHER = 'Sport::Lap::Other',
  SPORT_LAP_RUN = 'Sport::Lap::Run',
  SPORT_LAP_SWIM = 'Sport::Lap::Swim',
  SPORT_LAP_TRANSITION = 'Sport::Lap::Transition',
  SPORT_LAP_WALKING = 'Sport::Lap::Walking',
  SPORT_LAP_STRENGTH = 'Sport::Lap::Strength',
  SPORT_LAP_YOGA = 'Sport::Lap::Yoga',
}

export const SportLapTypesSchema = z.nativeEnum(SPORT_LAP_TYPES);
